import React from "react";
import "../template-file-css/document-file-template.css";

export const NBT_DischargeSummary = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NBT_DischargeSummary' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className="w-250">
                            <span className="eleHeader">Admission Date:</span>
                            <input type="date" id="txtAdmissionDate" name="txtAdmissionDate" className="add-only" />
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Discharge Date:</span>
                            <input type="date" id="txtDischargeDate" name="txtDischargeDate" className="add-only" />
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Date of Last Service:</span>
                            <input type="date" id="txtLastServiceDate" name="txtLastServiceDate" className="add-only" />
                        </td>
                    </tr>
                </table>
                <h5>Final Diagnosis</h5>
                <table>
                    <tr>
                        <td className="w-250">
                            <span className="eleHeader">AXIS I:</span>
                            <input type="text" id="txtAXISI" name="txtAXISI" className="add-only" />
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">AXIS II:</span>
                            <input type="text" id="txtAXISII" name="txtAXISII" className="add-only" />
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">AXIS III:</span>
                            <input type="text" id="txtAXISIII" name="txtAXISIII" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-550">
                            <span className="eleHeader">Goal</span>
                        </td>
                        <td className="w-200">
                            <span className="eleHeader">Goal Status</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-20">(1)</td>
                        <td className="w-530">
                            <input type="text" id="txtGoal1" name="txtGoal1" className="add-only" />
                        </td>
                        <td className="w-200">
                            <select id="ddlGoalStatus1" name="ddlGoalStatus1" className="add-only">
                                <option value=""></option>
                                <option value="Goal Met">Goal Met</option>
                                <option value="Goal Partially Met">Goal Partially Met</option>
                                <option value="Goal Not Met">Goal Not Met</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-20">(2) </td>
                        <td className="w-530"> <input type="text" id="txtGoal2" name="txtGoal2" className="add-only" />
                        </td>
                        <td className="w-200">
                            <select id="ddlGoalStatus2" name="ddlGoalStatus2" className="add-only">
                                <option value=""></option>
                                <option value="Goal Met">Goal Met</option>
                                <option value="Goal Partially Met">Goal Partially Met</option>
                                <option value="Goal Not Met">Goal Not Met</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-20"> (3)</td>
                        <td className="w-530">
                            <input type="text" id="txtGoal3" name="txtGoal3" className="add-only" />
                        </td>
                        <td className="w-200">
                            <select id="ddlGoalStatus3" name="ddlGoalStatus3" className="add-only">
                                <option value=""></option>
                                <option value="Goal Met">Goal Met</option>
                                <option value="Goal Partially Met">Goal Partially Met</option>
                                <option value="Goal Not Met">Goal Not Met</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-20">(4)</td>
                        <td className="w-530">
                            <input type="text" id="txtGoal4" name="txtGoal4" className="add-only" />
                        </td>
                        <td className="w-200">
                            <select id="ddlGoalStatus4" name="ddlGoalStatus4" className="add-only">
                                <option value=""></option>
                                <option value="Goal Met">Goal Met</option>
                                <option value="Goal Partially Met">Goal Partially Met</option>
                                <option value="Goal Not Met">Goal Not Met</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Summary of Progress in Treatment:</span>
                    <textarea id="txtProgressSummary" name="txtProgressSummary" className="add-only" rows="5"></textarea>
                </p>
                <h5>SNAPS</h5>
                <p className="w-750">
                    <span className="eleHeader">Strengths:</span>
                    <textarea id="txtStrengths" name="txtStrengths" className="add-only" rows="5"></textarea>
                </p>

                <p className="w-750">
                    <span className="eleHeader">Needs:</span>
                    <textarea id="txtNeeds" name="txtNeeds" className="add-only" rows="5"></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Abilities:</span>
                    <textarea id="txtAbilities" name="txtAbilities" className="add-only" rows="5"></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Preferences:</span>
                    <textarea id="txtPreferences" name="txtPreferences" className="add-only" rows="5"></textarea>
                </p>
                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">Reasons for Discharge:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbReason_ServicesComplete" name="cbReason_ServicesComplete" className="add-only" value="Services complete" /> No further treatment necessary; services complete
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbReason_Withdrew" name="cbReason_Withdrew" className="add-only" value="Withdrew from service" /> Withdrew from service
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbReason_Transferred" name="cbReason_Transferred" className="add-only" value="Transferred to another program" /> Transferred to another program
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbReason_Administrative" name="cbReason_Administrative" className="add-only" value="Administrative" /> Administrative
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbReason_Other" name="cbReason_Other" className="add-only" value="Other" /> Other
                            (List) <input type="text" id="txtReason_Other" name="txtReason_Other" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-750"><span className="eleHeader">Condition at Discharge:</span></td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbCondition_Worse" name="cbCondition_Worse" className="add-only" value="Worse" /> Worse
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbCondition_NoChange" name="cbCondition_NoChange" className="add-only" value="No Change" /> No Change
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbCondition_Improved" name="cbCondition_Improved" className="add-only" value="Improved" /> Improved
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbCondition_MuchImproved" name="cbCondition_MuchImproved" className="add-only" value="Much Improved" /> Much Improved
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbCondition_Comments" name="cbCondition_Comments" className="add-only" value="Comments" /> Comments:
                            <input type="text" id="txtCondition_Comments" name="txtCondition_Comments" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-750"><span className="eleHeader">Living Situation at Discharge:</span></td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbLiving_PrivateResidence" name="cbLiving_PrivateResidence" className="add-only" value="Private Residence" /> Private Residence
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbLiving_ResidentialCare" name="cbLiving_ResidentialCare" className="add-only" value="Residential Care" /> Residential Care
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbLiving_HomelessShelter" name="cbLiving_HomelessShelter" className="add-only" value="Homeless Shelter" /> Homeless Shelter
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbLiving_HomelessNoShelter" name="cbLiving_HomelessNoShelter" className="add-only" value="Homeless - Not in shelter" /> Homeless - Not in shelter
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbLiving_Jail" name="cbLiving_Jail" className="add-only" value="Jail Correctional Facility" /> Jail/Correctional Facility
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbLiving_FosterHome" name="cbLiving_FosterHome" className="add-only" value="Foster Home" /> Foster Home
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbLiving_PRTF" name="cbLiving_PRTF" className="add-only" value="PRTF" /> Psychiatric Residential Treatment Facility (PRTF)
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbLiving_Other" name="cbLiving_Other" className="add-only" value="Other" /> Other:
                            <input type="text" id="txtLiving_Other" name="txtLiving_Other" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-750"><span className="eleHeader">Primary Caregiver:</span></td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbCaregiver_Parent" name="cbCaregiver_Parent" className="add-only" value="Parent" /> Parent
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbCaregiver_Relative" name="cbCaregiver_Relative" className="add-only" value="Relative" /> Relative
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbCaregiver_FosterParent" name="cbCaregiver_FosterParent" className="add-only" value="Foster Parent" /> Foster Parent
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbCaregiver_Other" name="cbCaregiver_Other" className="add-only" value="Other" /> Other:
                            <input type="text" id="txtCaregiver_Other" name="txtCaregiver_Other" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Lawful Presence:</span>
                            <td className="w-150"><input type="radio" id="rbLawful_Yes" name="rbLawful" className="add-only" value="Yes" /> Yes</td>
                            <td className="w-150"><input type="radio" id="rbLawful_No" name="rbLawful" className="add-only" value="No" /> No</td>

                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Education (Highest Level Completed):</span>
                            <input type="text" id="txtEducation" name="txtEducation" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-750"><span className="eleHeader">Employment Status:</span></td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbEmpStatus_Employed" name="cbEmpStatus_Employed" className="add-only" value="Employed" /> Employed
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbEmpStatus_Unemployed" name="cbEmpStatus_Unemployed" className="add-only" value="Unemployed" /> Unemployed
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbEmpStatus_Student" name="cbEmpStatus_Student" className="add-only" value="Student" /> Student
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-750"><span className="eleHeader">School Setting:</span></td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbSchoolSetting_Mainstream" name="cbSchoolSetting_Mainstream" className="add-only" value="Mainstream" /> Mainstream
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbSchoolSetting_Alternative" name="cbSchoolSetting_Alternative" className="add-only" value="Alternative" /> Alternative
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbSchoolSetting_Vocational" name="cbSchoolSetting_Vocational" className="add-only" value="Vocational" /> Vocational
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbSchoolSetting_Other" name="cbSchoolSetting_Other" className="add-only" value="Other" /> Other:
                            <input type="text" id="txtSchoolSetting_Other" name="txtSchoolSetting_Other" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Legal Status:</span>
                            <td className="w-150"><input type="checkbox" id="cbLegalStatus_Voluntary" name="cbLegalStatus_Voluntary" className="add-only" value="Voluntary" /> Voluntary</td>
                            <td className="w-150"><input type="checkbox" id="cbLegalStatus_Involuntary" name="cbLegalStatus_Involuntary" className="add-only" value="Involuntary" /> Involuntary</td>
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Justice System Involvement:</span>
                            <td className="w-150"><input type="checkbox" id="cbJusticeSystem_Yes" name="cbJusticeSystem_Yes" className="add-only" value="Yes" /> Yes</td>
                            <td className="w-150"><input type="checkbox" id="cbJusticeSystem_No" name="cbJusticeSystem_No" className="add-only" value="No" /> No</td>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-750"><span className="eleHeader">Legal Custody:</span></td>
                    </tr>
                    <tr>
                        <td className="w-187"><input type="checkbox" id="cbLegalCustody_DFCS" name="cbLegalCustody_DFCS" className="add-only" value="DFCS" /> DFCS</td>
                        <td className="w-250"><input type="checkbox" id="cbLegalCustody_Other" name="cbLegalCustody_Other" className="add-only" value="Other Court Appointed Guardian" /> Other Court Appointed Guardian</td>
                        <td className="w-250"><input type="checkbox" id="cbLegalCustody_None" name="cbLegalCustody_None" className="add-only" value="None" /> None</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-750"><span className="eleHeader">Legal Involvement:</span></td>
                    </tr>
                    <tr>
                        <td className="w-187"><input type="checkbox" id="cbLegalInvolvement_DFCS" name="cbLegalInvolvement_DFCS" className="add-only" value="DFCS" /> DFCS</td>
                        <td className="w-187"><input type="checkbox" id="cbLegalInvolvement_Juvenile" name="cbLegalInvolvement_Juvenile" className="add-only" value="Juvenile Justice" /> Juvenile Justice</td>
                        <td className="w-187"><input type="checkbox" id="cbLegalInvolvement_Jail" name="cbLegalInvolvement_Jail" className="add-only" value="Jail" /> Jail/Law Enforcement</td>
                        <td className="w-187"><input type="checkbox" id="cbLegalInvolvement_Probation" name="cbLegalInvolvement_Probation" className="add-only" value="Probation" /> Probation</td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbLegalInvolvement_Other" name="cbLegalInvolvement_Other" className="add-only" value="Other" /> Other:
                            <input type="text" id="txtLegalInvolvement_Other" name="txtLegalInvolvement_Other" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Addiction/Type of Substance Used:</span>
                            <input type="text" id="txtAddiction" name="txtAddiction" className="add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Route:</span>
                            <input type="text" id="txtAddictionRoute" name="txtAddictionRoute" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Frequency of Use:</span>
                            <input type="text" id="txtUseFreq" name="txtUseFreq" className="add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Age of First Use:</span>
                            <input type="text" id="txtFirstUseAge" name="txtFirstUseAge" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Number of Prior Treatments:</span>
                            <input type="text" id="txtPriorTx" name="txtPriorTx" className="add-only" />
                        </td>
                        <td>&nbsp;</td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Discharge Medication:</span>
                    <textarea id="txtDischargeMeds" name="txtDischargeMeds" className="add-only" rows="5"></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Referral Made:</span>
                    <textarea id="txtReferralMade" name="txtReferralMade" className="add-only" rows="5"></textarea>
                </p>
                <table>
                    <tr>
                        <td className="w-450"><span className="eleHeader">CAFAS Scores for Youth’s Functioning</span></td>
                        <td className="w-150"><span className="eleHeader">Intake Scores</span></td>
                        <td className="w-150"><span className="eleHeader">Discharge Scores</span></td>
                    </tr>
                    <tr>
                        <td className="w-450">School/Work Role Performance</td>
                        <td className="w-150"><input type="text" id="txtWorkRolePerformance_Intake" name="txtWorkRolePerformance_Intake" className="add-only" /></td>
                        <td className="w-150"><input type="text" id="txtWorkRolePerformance_Discharge" name="txtWorkRolePerformance_Discharge" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Home Role Performance</td>
                        <td className="w-150"><input type="text" id="txtHomeRolePerformance_Intake" name="txtHomeRolePerformance_Intake" className="add-only" /></td>
                        <td className="w-150"><input type="text" id="txtHomeRolePerformance_Discharge" name="txtHomeRolePerformance_Discharge" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450" >Community Role Performance</td>
                        <td className="w-150"><input type="text" id="txtCommRolePerformance_Intake" name="txtCommRolePerformance_Intake" className="add-only" /></td>
                        <td className="w-150"><input type="text" id="txtCommRolePerformance_Discharge" name="txtCommRolePerformance_Discharge" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Behavior Towards Others</td>
                        <td className="w-150"><input type="text" id="txtBxOthers_Intake" name="txtBxOthers_Intake" className="add-only" /></td>
                        <td className="w-150"><input type="text" id="txtBxOthers_Discharge" name="txtBxOthers_Discharge" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Moods/Emotions</td>
                        <td className="w-150"><input type="text" id="txtMoodsEmotions_Intake" name="txtMoodsEmotions_Intake" className="add-only" /></td>
                        <td className="w-150"><input type="text" id="txtMoodsEmotions_Discharge" name="txtMoodsEmotions_Discharge" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Self-Harmful Behavior</td>
                        <td className="w-150"><input type="text" id="txtSelfHarmBx_Intake" name="txtSelfHarmBx_Intake" className="add-only" /></td>
                        <td className="w-150"><input type="text" id="txtSelfHarmBx_Discharge" name="txtSelfHarmBx_Discharge" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Substance Abuse</td>
                        <td className="w-150"><input type="text" id="txtSA_Intake" name="txtSA_Intake" className="add-only" /></td>
                        <td className="w-150"><input type="text" id="txtSA_Discharge" name="txtSA_Discharge" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Thinking</td>
                        <td className="w-150"><input type="text" id="txtThinking_Intake" name="txtThinking_Intake" className="add-only" /></td>
                        <td className="w-150"><input type="text" id="txtThinking_Discharge" name="txtThinking_Discharge" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Total For Youth based on 8 Scales</td>
                        <td className="w-150"><input type="text" id="txtCAFASTotal_Intake" name="txtCAFASTotal_Intake" className="add-only" /></td>
                        <td className="w-150"><input type="text" id="txtCAFASTotal_Discharge" name="txtCAFASTotal_Discharge" className="add-only" /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-375 signature">&nbsp;</td>
                        <td className="w-375 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className=" w-375 small">Client Signature</td>
                        <td className="w-375 small">Date</td>
                    </tr>
                    <tr>
                        <td className="w-375 signature">&nbsp;</td>
                        <td className="w-375 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Authorized Family/Legal Representative Signature</td>
                        <td className="w-375 small">Date</td>
                    </tr>
                    <tr>
                        <td className="w-187 signature">&nbsp;</td>
                        <td className="w-187 signature">&nbsp;</td>
                        <td className="w-187 signature">&nbsp;</td>
                        <td className="w-187 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-187 small">Print Staff Name</td>
                        <td className="w-187 small">Credentials</td>
                        <td className="w-187 small">Staff Signature</td>
                        <td className="w-187 small">Date</td>
                    </tr>
                </table>
            </div>
        </form>
    )
}